import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal, ViewEncapsulation } from '@angular/core';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

@Component({
    selector: 'st-text-field',
    templateUrl: './text-field.html',
    styleUrls: ['./text-field.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-text-field',
    },
})
export class TextFieldComponent extends EnpsControlComponent<string | number> {
    type = input<'text' | 'password' | 'number'>('text');
    showLinks = input(false, {
        transform: coerceBooleanProperty,
    });
    textToHighlight = input<string>('');

    inEditMode = signal(true);
    internalValue = signal<string | number>(null);
    onEnter = output<string | number>();

    constructor() {
        super();
        effect(
            () => {
                this.inEditMode.set(!this.showLinks());
                this.internalValue.set(this.value());
            },
            { allowSignalWrites: true }
        );
    }

    displayValue = computed(() => {
        return (this.value() as string) || this.placeholder() || '';
    });

    keyPressed(event) {
        if (event.keyCode === 27) {
            this.elmRef.nativeElement.querySelector('input').blur();
            this.inEditMode.set(false);
        }

        if (event.keyCode === 13 || event.key === 'Enter') {
            this.onValueChanged();
            this.onEnter.emit(this.internalValue());
        }
    }

    onNgModelChanged(value: string | number) {
        this.internalValue.set(value);
    }

    onValueChanged() {
        this.changed.emit(this.internalValue());
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(false);
        }
    }

    onBlur() {
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(false);
        }
    }

    onFocus() {
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(true);
        }
    }
}
